import * as Yup from 'yup';
export const schema = Yup.object().shape({
  price: Yup.number()
    .required('مقدار نیاز مالی ضروری می باشد.')
    .typeError('مقدار عددی وارد نمایید.'),
  duration: Yup.number()
    .required('مدت زمان آگهی ضروری می باشد.')
    .typeError('مقدار عددی وارد نمایید.'),
});
